import type {
  CampaignPipelineDefinition,
  PipelineTone,
} from "@/marketing/models/campaignPipeline";

export interface PipelineToneStyle {
  pill: string;
  dot: string;
  fill: string;
}

const NEUTRAL_STYLE: PipelineToneStyle = {
  pill: "tw-bg-slate-100 tw-text-slate-700",
  dot: "tw-bg-slate-500",
  fill: "hsl(215 18% 60%)",
};

const TONE_STYLES: Record<PipelineTone, PipelineToneStyle> = {
  neutral: NEUTRAL_STYLE,
  info: {
    pill: "tw-bg-blue-100 tw-text-blue-700",
    dot: "tw-bg-blue-600",
    fill: "#2563eb",
  },
  progress: {
    pill: "tw-bg-violet-100 tw-text-violet-700",
    dot: "tw-bg-violet-600",
    fill: "#7c3aed",
  },
  warning: {
    pill: "tw-bg-amber-100 tw-text-amber-800",
    dot: "tw-bg-amber-600",
    fill: "#d97706",
  },
  success: {
    pill: "tw-bg-emerald-100 tw-text-emerald-800",
    dot: "tw-bg-emerald-600",
    fill: "#16a34a",
  },
};

// The last stage of a pipeline renders teal when it is a success tone, so "done" stays distinct from "published".
const TERMINAL_SUCCESS_STYLE: PipelineToneStyle = {
  pill: "tw-bg-teal-100 tw-text-teal-800",
  dot: "tw-bg-teal-600",
  fill: "#0d9488",
};

export function getStageToneStyle(
  definition: CampaignPipelineDefinition,
  stage: string,
): PipelineToneStyle {
  const stageDefinition = definition.stages.find((s) => s.stage === stage);
  if (!stageDefinition) return NEUTRAL_STYLE;
  const isTerminal =
    definition.stages[definition.stages.length - 1]?.stage === stage;
  if (stageDefinition.tone === "success" && isTerminal) {
    return TERMINAL_SUCCESS_STYLE;
  }
  return TONE_STYLES[stageDefinition.tone] ?? NEUTRAL_STYLE;
}
